import React from "react";
import {defaultPageConfig, Page, PageConfig} from "/src/domain/shared/Page";
import '../../i18n';

import {User} from "/src/domain/shared/User";

import {mountComponentToContainer} from "/src/domain/shared/mountUtils";
import {changePageLanguage} from "/src/domain/shared/changePageLanguage";
import {ChallengeUserRatingData} from "/src/domain/challenges/ChallengeUserRatingData";
import {ChallengeUserRatingApp} from "/src/ui/challengeUserRating/ChallengeUserRatingApp";

const mockPageData = require('./mock.json');

window.mountPage = mountPage;


function mountPage(page: Page, pageData: ChallengeUserRatingData, currentUser?: User, pageConfig?: PageConfig) {
    if (page !== Page.CHALLENGE_USER_RATING) {
        console.error('Unknown page type');
        return;
    }

    if (currentUser?.lang)
        changePageLanguage(currentUser.lang);

    mountComponentToContainer(page, pageData, currentUser, pageConfig ? pageConfig : defaultPageConfig, ChallengeUserRatingApp)
}

mountPage(Page.CHALLENGE_USER_RATING, mockPageData, undefined);